import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/shared/shared.module";
import { AssessmentLinkedOverviewComponent } from "./components/linked-overview/assessment-linked-overview.component";

@NgModule({
    exports: [AssessmentLinkedOverviewComponent],
    imports: [CommonModule, SharedModule, AssessmentLinkedOverviewComponent]
})
export class AssessmentSharedModule {}
